module.exports = __webpack_public_path__ + "static/media/investorsDarkMobile.f2ff2445.png";